import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {EContactFieldType, EProjectStatus, EProjectType, ProjectModel} from '../../../@models';
import {NbToastrService} from '@nebular/theme';
import {FormListBusinessUnitRendererComponent} from '../form-list/renderer/form-list-business-unit-renderer.component';
import {ApiService} from '../../../@core/service/api.service';
import {FormListProjectStatusRenderComponent} from '../form-list/renderer/form-list-project-status-render.component';
import {FormListProjectTypeRenderComponent} from '../form-list/renderer/form-list-project-type-render.component';
import {EnumKeysPipe} from '../../../@theme/pipes';
import {FormListDateRendererComponent} from '../form-list/renderer/form-list-date-renderer.component';
import {FormListDateEditComponent} from '../form-list/renderer/form-list-date-edit.component';
import {FormListBusinessRendererComponent} from '../form-list/renderer/form-list-business-renderer.component';
import {FormListMaterialRendererComponent} from '../form-list/renderer/form-list-material-renderer.component';
import { FormListComponent } from '../form-list/form-list.component';
import { SharedDataService } from '../../../@core/service/shared-data.service';

@Component({
    selector: 'ngx-form-list-project',
    templateUrl: './form-list-project.component.html',
    styleUrls: ['./form-list-project.component.scss']
})
export class FormListProjectComponent implements OnInit, OnChanges {
  @Input() projects: ProjectModel[];
  @Output() projectsChange: EventEmitter<ProjectModel[]> = new EventEmitter<ProjectModel[]>();

  projectColumns = null;

  filteredProjects = [];

  constructor(
    private toastrService: NbToastrService,
    private api: ApiService,
    private data: SharedDataService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.projects.currentValue) {
      this.filteredProjects = this.projects.filter(f => f.active);
    }
  }

  async ngOnInit() {

    await this.data.loadMaterials();

    const bus = await this.data.loadBusinessUnits();
      
    const buList = bus.map(x => {
      return {title: x.name, value: x._id};
    });
    const projectTypeMap: { value: number; title: string }[] = [];

    for (const n in EProjectType) {
      if (typeof EProjectType[n] === 'number') {
        projectTypeMap.push({value: <any>EProjectType[n], title: n});
      }
    }
    const projectStatusMap: { value: number; title: string }[] = [];

    for (const n in EProjectStatus) {
      if (typeof EProjectStatus[n] === 'number') {
        projectStatusMap.push({value: <any>EProjectStatus[n], title: n});
      }
    }

    this.projectColumns = {
      businessUnit: {
        title: 'BusinessUnit',
        type: 'custom',
        renderComponent: FormListBusinessUnitRendererComponent,
        editor: {
          type: 'list',
          config: {
            selectText: 'Select',
            list: buList,
          },
        },
        filter: false,
      },
      name: {
        title: 'Name',
        type: 'text',
        filter: false,
      },
      /*material: {
        title: 'Material',
        type: 'custom',
        renderComponent: FormListMaterialRendererComponent,
        editor: {
          type: 'list',
          config: {
            list: [{value: null, title: 'None'}].concat(materials.map(x => {
              return {value: x._id, title: x.name};
            })),
          },
        },
        filter: false,
      },*/
      type: {
        title: 'Type',
        type: 'custom',
        renderComponent: FormListProjectTypeRenderComponent,
        editor: {
          type: 'list',
          config: {
            selectText: 'Select',
            list: projectTypeMap,
          },
        },
        filter: false,
      }, /*
      potential: {
        title: 'Business potential (per YEAR)',
        filter: false,
      },
      currency: {
        title: 'Currency',
        filter: false,
      },
      probability: {
        title: 'Probability',
        filter: false,
      },
      kickoff: {
        title: 'Kick off date',
        type: 'custom',
        renderComponent: FormListDateRendererComponent,
        editor: {
          type: 'custom',
          component: FormListDateEditComponent,
        },
        filter: false,
      },
      firstPo: {
        title: 'Potential first PO',
        type: 'custom',
        renderComponent: FormListDateRendererComponent,
        editor: {
          type: 'custom',
          component: FormListDateEditComponent,
        },
        filter: false,
      },
      offerDate: {
        title: 'Estimated Offer Date',
        type: 'custom',
        renderComponent: FormListDateRendererComponent,
        editor: {
          type: 'custom',
          component: FormListDateEditComponent,
        },
        filter: false,
      },
      orderDate: {
        title: 'Estimated Order Date',
        type: 'custom',
        renderComponent: FormListDateRendererComponent,
        editor: {
          type: 'custom',
          component: FormListDateEditComponent,
        },
        filter: false,
      },*/
      status: {
        title: 'Status',
        type: 'custom',
        renderComponent: FormListProjectStatusRenderComponent,
        editor: {
          type: 'list',
          config: {
            selectText: 'Select',
            list: projectStatusMap,
          },
        },
        filter: false,
      },
      /*showInReport: {
        title: 'Show in reports',
        type: 'text',
        editor: {
          type: 'checkbox',
        },
        filter: false,
      },*/
      description: {
        title: 'Remark',
        type: 'text',
        editor: {
          type: 'textarea',
        },
        filter: false,
      },
    };
    // setTimeout(() => {
    //   if (this.formList) this.formList.reloadSettings();
    // })
    // console.log(this.projectColumns.businessUnit.editor.config.list )
  }

  change(event) {
    this.projectsChange.emit(event);
  }

  validate(event) {
    if (event.newData.name === '') {
      event.confirm.reject('Name is required');
      this.toastrService.danger('Name is required', 'Error');
    } else if (event.newData.type === '') {
      event.confirm.reject('Type is required');
      this.toastrService.danger('Type is required', 'Error');
    } else event.confirm.resolve();
  }

}
